import React, { useState, useLayoutEffect } from 'react'
import bowser from 'bowser'
import allowedBrowsers from 'constants/allowedBrowsers'
import PageLayout from 'components/PageLayout'
import Seo from 'components/Seo'
import Header from 'components/Header'
import OldBrowsersBanner from 'components/OldBrowsersBanner'
import HomeSection1 from 'components/sections/HomeSection1'
import HomeSection2 from 'components/sections/HomeSection2'
import ReadAboutUs from 'components/ReadAboutUs'
import BrandsList from 'components/BrandsList'

const IndexPage = () => {
  const [isModernBrowser, setIsModernBrowser] = useState(true)

  useLayoutEffect(() => {
    const browser =
      window && window.navigator && bowser.getParser(window.navigator.userAgent)

    setIsModernBrowser(browser.satisfies(allowedBrowsers))
  }, [])

  return (
    <PageLayout>
      <Seo />
      <Header isTransparent />
      {isModernBrowser ? (
        <>
          <HomeSection1 />
          <BrandsList />
          <HomeSection2 />
          <ReadAboutUs />
        </>
      ) : (
        <>
          <OldBrowsersBanner />
          <HomeSection1 />
        </>
      )}
    </PageLayout>
  )
}

export default IndexPage
